module.exports = __webpack_public_path__ + "media/images/next-arrow-2bdf5366a0d135983b31ade10e60018b.svg";